module.exports = __webpack_public_path__ + "gib1m09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ranks/49.jpg
// module id = 577
// module chunks = 1